import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=8646eb34&"
import script from "./HistoryView.vue?vue&type=script&lang=ts&"
export * from "./HistoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports